import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ConditionsUtilisationPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <section className="bg-[#E30022] text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl lg:text-4xl font-serif">Conditions d'utilisation</h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8 lg:p-12 prose prose-gray max-w-none">
          <p className="text-gray-500 mb-8">Dernière mise à jour : Janvier 2026</p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">1. Objet</h2>
          <p className="text-gray-600 mb-4">
            Les présentes conditions générales d'utilisation (CGU) régissent l'accès et l'utilisation du site web recrutement-suisse.ch (ci-après le "Site") édité par Recrutement Suisse SA.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">2. Acceptation des conditions</h2>
          <p className="text-gray-600 mb-4">
            En accédant au Site, vous acceptez sans réserve les présentes CGU. Si vous n'acceptez pas ces conditions, vous devez cesser d'utiliser le Site.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">3. Services proposés</h2>
          <p className="text-gray-600 mb-4">
            Le Site propose les services suivants :
          </p>
          <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
            <li>Consultation d'offres d'emploi</li>
            <li>Dépôt de candidatures et de CV</li>
            <li>Informations sur nos services de recrutement</li>
            <li>Ressources et conseils carrière</li>
            <li>Études de rémunération</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">4. Inscription et compte utilisateur</h2>
          <p className="text-gray-600 mb-4">
            Certains services peuvent nécessiter la création d'un compte. Vous vous engagez à fournir des informations exactes et à maintenir la confidentialité de vos identifiants de connexion.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">5. Propriété intellectuelle</h2>
          <p className="text-gray-600 mb-4">
            L'ensemble des contenus du Site (textes, images, logos, graphismes, etc.) est protégé par le droit d'auteur et appartient à Recrutement Suisse SA ou à ses partenaires. Toute reproduction, représentation ou diffusion, totale ou partielle, est interdite sans autorisation préalable.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">6. Responsabilités de l'utilisateur</h2>
          <p className="text-gray-600 mb-4">L'utilisateur s'engage à :</p>
          <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
            <li>Utiliser le Site de manière légale et loyale</li>
            <li>Ne pas publier de contenu illicite, diffamatoire ou portant atteinte aux droits de tiers</li>
            <li>Fournir des informations exactes dans ses candidatures</li>
            <li>Ne pas tenter de perturber le fonctionnement du Site</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">7. Limitation de responsabilité</h2>
          <p className="text-gray-600 mb-4">
            Recrutement Suisse SA s'efforce d'assurer l'exactitude des informations publiées mais ne peut garantir l'absence d'erreurs. Le Site est fourni "en l'état" sans garantie de disponibilité permanente. Nous ne pouvons être tenus responsables des dommages directs ou indirects résultant de l'utilisation du Site.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">8. Liens externes</h2>
          <p className="text-gray-600 mb-4">
            Le Site peut contenir des liens vers des sites tiers. Nous n'exerçons aucun contrôle sur ces sites et déclinons toute responsabilité quant à leur contenu.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">9. Modification des CGU</h2>
          <p className="text-gray-600 mb-4">
            Nous nous réservons le droit de modifier les présentes CGU à tout moment. Les modifications entrent en vigueur dès leur publication sur le Site.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">10. Droit applicable et juridiction</h2>
          <p className="text-gray-600 mb-4">
            Les présentes CGU sont régies par le droit suisse. Tout litige relatif à l'utilisation du Site sera soumis à la compétence exclusive des tribunaux de Zurich.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">11. Contact</h2>
          <p className="text-gray-600 mb-4">
            Pour toute question relative aux présentes CGU :<br/>
            Recrutement Suisse SA<br/>
            Limmatquai 112<br/>
            8001 Zürich<br/>
            <a href="mailto:contact@recrutement-suisse.ch" className="text-[#E30022] hover:underline">contact@recrutement-suisse.ch</a>
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ConditionsUtilisationPage;
